<template>
  <div class="embedded-designer">
    <TemplateDesignerV2
      v-if="visible"
      ref="templateDesigner"
      :billType="billType"
      :billTypeName="billTypeName"
      :billNo="billNo"
      :templateId="templateId"
      :billData="billData"
      :embedded="true"
      @close="onClose"
      @saved="onSaved"
    />
  </div>
</template>

<script>
import TemplateDesignerV2 from './TemplateDesignerV2.vue'

export default {
  name: 'EmbeddedDesigner',
  components: {
    TemplateDesignerV2
  },
  props: {
    billType: { type: String, default: '' },
    billTypeName: { type: String, default: '' },
    billNo: { type: String, default: '' },
    templateId: { type: [String, Number], default: null },
    billData: { type: Object, default: null }
  },
  data() {
    return {
      visible: true
    }
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    onSaved() {
      this.$emit('saved')
    }
  }
}
</script>

<style scoped>
.embedded-designer {
  height: 100%;
  width: 100%;
}
</style>